import Immutable from 'immutable';

import type { Notification } from 'js/src/client';
import StoreORM from 'js/src/data/store-orm';
import type { RootState } from 'js/src/libs/RootState';

/* SELECTORS */
export function _selectNotification(state: RootState) {
    return state.notifications;
}

export function selectNotificationsUiState(state: RootState) {
    return _selectNotification(state)?.uiState;
}

export const _selectNotificationList = (state: RootState) => {
    return _selectNotification(state)?.notifications_list;
};

export const selectAllNotificationIds = (state: RootState): Immutable.List<number> => {
    const notificationListState = _selectNotificationList(state);

    if (notificationListState) {
        const orm = new StoreORM<Notification>(notificationListState);
        return orm.getAllIds();
    }

    return Immutable.List<number>();
};

export const selectNotificationById = (state: RootState, notificationId: number) => {
    const notifications = _selectNotificationList(state);
    const orm = new StoreORM<Notification>(notifications);

    if (orm.data) {
        return orm.getById(notificationId);
    }

    return undefined;
};

export const selectHasUnreadNotifications = (state: RootState) => {
    return _selectNotification(state)?.has_unread;
};
